import { Component, computed, effect, inject, input, signal } from '@angular/core';
import { createGaugeChart } from '@charts';
import * as Highcharts from 'highcharts';
import { HighchartsChartComponent, providePartialHighcharts } from 'highcharts-angular';
import { WidgetGauge } from 'libs/dashboards/src/lib/models';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { DashboardStore } from '../../../stores';

@Component({
  imports: [HighchartsChartComponent, NgxSkeletonLoaderModule],
  providers: [
    providePartialHighcharts({
      modules: () => [
        import('highcharts/esm/highcharts-more'),
      ],
    }),
  ],
  selector: 'avs-gauge',
  styleUrl: './gauge.component.scss',
  templateUrl: './gauge.component.html',
})
export class GaugeComponent {
  config = input.required<WidgetGauge>();

  protected chartRef = signal<Highcharts.Chart | null>(null);
  protected currentWattage = computed(() => this.chartState()?.timeseries?.at(-1)?.value);
  protected highchartOptions = computed(() => createGaugeChart(this.config(), this.chartState()));
  protected Highcharts: typeof Highcharts = Highcharts;
  protected isLoading = computed(() => !this.chartState());

  private store = inject(DashboardStore);
  private chartKey = signal('');
  private chartState = computed(() => this.store.chartData(this.chartKey())());

  constructor() {
    effect(() => {
      if (this.config()) {
        this.chartKey.set(this.store.loadChartData(this.config().deviceId, {
          latestOnly: true,
          point: this.config().datapointName,
        }));
      }
    });
  }
}
